import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;
  font-size: 42px;
  width: 100%;
`;
Container.displayName = 'Container';

export const Title = styled.h3`
  margin: 0;
  text-align: center;
  width: 100%;
`;
Title.displayName = 'Title';

export const UsernamesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-width: 130px;
  padding: 16px;
  width: 100%;
`;
UsernamesContainer.displayName = 'UsernamesContainer';

export const UserNameText = styled.p`
  background: #ffa726;
  border-radius: 8px;
  color: #333;
  font-size: ${({ winner }) => (winner ? '35px' : '18px')};
  font-weight: ${({ winner }) => (winner ? '600' : '500')};
  margin: 8px;
  padding: 8px 12px;
`;
UserNameText.displayName = 'UserNameText';
